import cn from "classnames";

import { roundAndDropTrailingZeros, translate } from "@ascendnow/shared";

import { StatCardStarIllustration } from "../AscIllustrations";
import AscImage from "../AscImage/AscImage";
import coinsImage from "../../assets/images/coins-image.png";
import styles from "./AscChallengeFeedbackCard.module.scss";

export type AscChallengeFeedbackRewardProps = {
  value: number;
  type: "coins" | "points";
  className?: string;
};

export default function AscChallengeFeedbackReward({
  value,
  type,
  className,
}: AscChallengeFeedbackRewardProps) {
  return (
    <div
      className={cn(
        styles.reward,
        {
          [styles.coins]: type === "coins",
          [styles.points]: type === "points",
        },
        className
      )}
    >
      <div className={styles.iconWrapper}>
        {type === "coins" ? (
          <AscImage src={coinsImage} className={styles.icon} />
        ) : (
          <StatCardStarIllustration className={styles.icon} />
        )}
      </div>
      <div className={styles.rewardText}>
        <div className={styles.value}>{roundAndDropTrailingZeros(value)}</div>
        <div className={styles.label}>
          {translate(type === "coins" ? "coins" : "points")}
        </div>
      </div>
    </div>
  );
}
